import { Col, Row } from "antd"
import PropTypes from "prop-types"
import { PricesAndTypes } from "../PricesAndTypes"
import { useTranslation } from "react-i18next"

export const PerPersonFormItems = ({ form, record }) => {
  const [t] = useTranslation()

  return (
    <Row className="mb-l" gutter={16}>
      <Col span={24}>
        <PricesAndTypes form={form} title={t("experiences.scheduling.sections.length_and_rates.rates_block_title")} record={record} />
      </Col>
    </Row>
  )
}

PerPersonFormItems.propTypes = {
  form: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  record: PropTypes.object,
};
